module.exports = __webpack_public_path__ + "static/home_hongong-56a4d7e00b5790ac3f0c74db374ad3e7.png";